export default __webpack_public_path__ + "static/media/Fair-en.a9b186a8.png";